import * as types from "./actionTypes";

export const getList = (sort) => {
  return {
    type: types.NOTIFICATION_LIST_REQUEST,
    sort
  };
};

export const getListSuccess = (data) => {
  return {
    type: types.NOTIFICATION_LIST_SUCCESS,
    payLoad: data
  };
};

export const getListFailure = (error) => {
  return {
    type: types.NOTIFICATION_LIST_FAILURE,
    payLoad: error
  };
};

export const read = (notificationId) => {
  return {
    type: types.NOTIFICATION_READ_REQUEST,
    id: notificationId
  }
};